jQuery(document).ready(function($) {

    function initialize() {
      if(document.getElementById("map_canvas")) {
        var center_location = new google.maps.LatLng(51.54086701573874,-0.1577575802803);

        var mapOptions = {
          zoom: 13,
          center: center_location,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: styles
        };

        var map = new google.maps.Map(document.getElementById("map_canvas"),
              mapOptions);

        var pin = wp_object.directory_uri.template_directory_uri + '/images/mapPin.png';
        var markersInfo = wp_object.google_maps,
            hideMarkers = wp_object.hide_markers;
        
        var markers = [],
            infoWindows = [];

        if(!hideMarkers) {
          for(var i = 0; i < markersInfo.length; i++) {
            var marker = new google.maps.Marker({
              position: new google.maps.LatLng(markersInfo[i].marker.lat, markersInfo[i].marker.lng),
              map: map,
              icon: pin,
              title: markersInfo[i].location_title
            });


            var content = '<div class="gMap_overlay">'+
            '<h3>' + markersInfo[i].location_title + '</h3>'+
            '<p>' + markersInfo[i].location_description + '</p>'+
            '</div>';

            var infoWindow = new google.maps.InfoWindow({
              content: content
            });

            markers.push(marker);
            infoWindows.push(infoWindow);
          }

          markers.forEach(function(marker, index) {
            marker.addListener('click', function(event) {
              infoWindows[index].open(map, marker);
            });
          });
        }

        var styles = [
          {
            featureType: "all",
            stylers: [
              { saturation: -100 }
            ]
          }
        ];
        map.setOptions({
          styles: styles,
          scrollwheel: false
        });
      } 
    } // end initialize

    window.onload = function () { initialize(); }

    $('body .mobile-menu').height($(window).height());

    $(window).resize(function(){
        $('body .mobile-menu').height($(window).height());
    });

    var moreInfo = $('.moreInfo');
    moreInfo.next().hide();
    moreInfo.click(function(){
        $(this).hide().next().slideToggle(100);
    });

    // Drop Slide
    var dropSlide = $('.dropSlide');
    dropSlide.next().hide();
    dropSlide.click(function(){
        $(this).next().slideToggle(100);
    });

  $('.menu-button-interact').click(function() {

      if ($('html').hasClass('mobile-menu-opened'))
      {
          $('html').toggleClass('mobile-menu-opened');
          $('html .mobile-menu').animate({'top': '-100%'}, 250);
      }
      else
      {
          $('html').toggleClass('mobile-menu-opened');
          $('html .mobile-menu').animate({'top': '0%'}, 250);
      }

  });

    $(window).load(function() {
        $('.flexslider').flexslider({
            slideshowSpeed: 6000
        });
    });

    $(document).ready(function() {
        $('#sidrToggle').sidr({
            side: 'right',
            name: 'sidr',
            source: '#sidrNav'
        });
        $('.sidr-class-mainNav').after('<div class="closeNav"><button id="closeNav" class="buttonTwo">close</button></div>');

        $('#closeNav').click(function() {
            $.sidr('close');
        });

        $('nav.menuPanel').hide();

        $('#showMenu').click(function(){
            $(this).next('nav.menuPanel').slideToggle(100);
            return false;
        });

        $('#input_3_1').addClass('call-to-action__email')
        $('#gform_submit_button_3').addClass('button button--blue')
    })

    jQuery(function() {
        $('a[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $('html, body').animate({
                scrollTop: target.offset().top
                }, 1000);
                return false;
            }
            }
        });
    });

    // Find all YouTube videos
    var $allVideos = jQuery("iframe[src^='https://www.youtube.com']"),

        // The element that is fluid width
        $fluidEl = jQuery(".blog-single__content");

    // Figure out and save aspect ratio for each video
    $allVideos.each(function() {

    jQuery(this)
        .data('aspectRatio', this.height / this.width)

        // and remove the hard coded width/height
        .removeAttr('height')
        .removeAttr('width');

    });

    // When the window is resized
    jQuery(window).resize(function() {

    var newWidth = $fluidEl.width();

    // Resize all videos according to their own aspect ratio
    $allVideos.each(function() {

        var $el = $(this);
        $el
        .width(newWidth)
        .height(newWidth * $el.data('aspectRatio'));

    });

    // Kick off one resize to fix all videos on page load
    }).resize();
});
